export default __webpack_public_path__ + "static/media/MaskGroup321.99696501.png";